import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getRamosPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`descripcion_ramo=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/ramos", queryString);
};


export const getRamoById = async (id) => {
    const res = await getData(`/ramos/${id}`)
    return res
}


export const postRamo = async (body) => {
    const res = await postData('/ramos', body)
    return res
}

export const patchRamo = async (id, body) => {
    const res = await patchData(`/ramos/${id}`, body)
    return res
}

export const deleteRamo = async (id) => {
    const res = await deleteData(`/ramos/${id}`)
    return res
}